import { FC } from 'react';
import { LabeledSectionSkeleton } from '../../../../shared/labeled-section/labeled-section.skeleton';
import { RequestDateItemSkeleton } from './request-date-item/request-date-item.skeleton';

export const RequestDateSectionSkeleton: FC = (props) => {
  return (
    <LabeledSectionSkeleton labelWidth={150}>
      <RequestDateItemSkeleton />
    </LabeledSectionSkeleton>
  );
};
